import { useMutation } from '@tanstack/react-query';
import { Organization } from '../../types/organization.types';
import { updateOrganization } from '../../api/remiApi';

export const useUpdateOrganizationSettings = (onSuccess?: () => void) => {
  const { mutateAsync: updateSettings, isPending } = useMutation({
    mutationFn: ({ id, data }: { id: string; data: Partial<Organization> }) =>
      updateOrganization(id, data as Record<string, unknown>),
    onSuccess: () => {
      onSuccess?.();
    },
  });

  return {
    updateSettings,
    isPending,
  };
};
